import { actionCreatorFactory } from "typescript-fsa";
import { licensedata } from "../typing/table_typing";


const actionCreator = actionCreatorFactory("LicenseTABLE");

 const resetData = actionCreator<{license:licensedata[]}>("LicenseTABLE_RESETDATA");

 export const TableThingyActions = { resetData}


